<h1 mat-dialog-title>
    Condutor
</h1>

<button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
</button>

<mat-dialog-content>
    <div *ngIf="temCondutorContrato" class="condutor-contrato">
        <label><b>Condutor:</b> {{ condutorContrato.nomeCondutor }}</label>
        <label><b>CPF:</b> {{ condutorContrato.cpf }}</label>
    </div>

    <div *ngIf="!temCondutorContrato">
        <label>Não há nenhum condutor cadastrado no contrato do veículo.</label>
    </div>
</mat-dialog-content>

<div mat-dialog-actions align="end">
    <button *ngIf="temCondutorContrato" type="button" mat-flat-button (click)="close()">
        Cancelar
    </button>

    <button *ngIf="!temCondutorContrato" type="button" mat-flat-button (click)="close()">
        Fechar
    </button>

    <button *ngIf="temCondutorContrato" type="submit" mat-flat-button [disabled]="!condutorContrato"
        (click)="putCondutorMulta()">
        Confirmar
    </button>
</div>